// containers/NotFound.js
function NotFound() {
  return (
    <div className='not-found'>
        <div className='not-found--container'>
            <h1>Error</h1>
            <img src='https://i.imgur.com/eOeoeq0.png' alt='image of an astronaut beside a flag that reads Page Not Found'/>
        </div>
    </div>
  );
}

export default NotFound;
